import { render, staticRenderFns } from "./addExpense.vue?vue&type=template&id=3f6f8e38"
import script from "./addExpense.vue?vue&type=script&lang=js"
export * from "./addExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports